import { useEffect, useState } from 'react';
import './newUserTextCell.scss';
import { INewUpdatedUser } from '../manageUsersModel';

interface NewUserTextCellRendererProps {
  colDef?: any;
  data?: any;
  onDomainRowChange: (name: string, value: string, rowData: any) => void;
  domainUsers: INewUpdatedUser[];
}

export const NewUserTextCellRenderer = (
  props: NewUserTextCellRendererProps
) => {
  const [inputValue, setInputValue] = useState<string>('');
  const columnDef = props?.colDef;
  const user = props.data?.userDetails;
  const domainList = props.domainUsers;

  useEffect(() => {
    if (domainList?.length && user?.isAllowedDomain) {
      const currentUser = domainList?.find((v) => v.mail === user?.mail);
      setInputValue(
        columnDef?.field === 'userLname'
          ? currentUser?.surname ?? ''
          : currentUser?.givenName ?? ''
      );
    }
    // eslint-disable-next-line no-autofix/react-hooks/exhaustive-deps
  }, []);

  const getColumnData = () => {
    if (columnDef?.field === 'userLname') return user?.surname;
    return user?.givenName;
  };

  return (
    (user && (
      <>
        {user?.isNewAddedRow && user?.isAllowedDomain ? (
          <div
            className={`new-user-text-cell ${
              inputValue.length === 0 ? 'empty' : ''
            }`}
          >
            <input
              type="text"
              name={columnDef?.field ?? ''}
              autoComplete="off"
              placeholder={
                columnDef?.field === 'userLname' ? 'Last name' : 'First name'
              }
              value={inputValue}
              onChange={({ target }) => setInputValue(target.value)}
              onBlur={({ target }) =>
                props.onDomainRowChange(target.name, target.value, user)
              }
            />
          </div>
        ) : (
          <div className="user-details">{getColumnData()}</div>
        )}
      </>
    )) ||
    null
  );
};
